import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'ps20-shop-ndbx-design',
  templateUrl: './ndbx-design.component.html',
  styleUrls: ['./ndbx-design.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class NdbxDesignComponent {}
